import React, { useEffect, useState } from 'react';
import { GalleryStyles as styles } from "./chat.tailwind";
import { Close } from '@mui/icons-material';
import { Skeleton } from '@mui/material';

// const GradientSkeleton = styled(Skeleton)(({ theme }) => ({
//     height: '210px',
//     // height: '100%',
//     background: "linear-gradient(90deg, #0d0d1f, #1a1a3f, #320d3e, #0d0d1f)", // Adjust gradient stops
//     backgroundSize: "200% 100%",
//     animation: "shimmer 2s infinite",
//     borderRadius: "12px", // Optional rounded edges
//     "@keyframes shimmer": {
//       "0%": {
//         backgroundPosition: "200% 0",
//       },
//       "100%": {
//         backgroundPosition: "-200% 0",
//       },
//     },
//   }));

const ImagePreview = ({ url, isRejected = false, uploadProgress, insideGallery = false, isFullScreen = false, toggleFullScreen }) => {
    const [imageLoaded, setImageLoaded] = useState(false);

    const getStyle = () => {
        if (insideGallery) {
            return '210px';
        } else {
            if (isRejected) {
                return '100%';
            } else if (uploadProgress?.isUploading) {
                return '70%';
            } else {
                return '100%';
            }
        }
    };

    const handleImageLoad = () => {
        setImageLoaded(true);
    };

    useEffect(() => {
        if (isFullScreen) {
            document.body.style.overflow = 'hidden';

            const handleEscKey = (event) => {
                if (event.key === 'Escape') {
                    toggleFullScreen();
                }
            };

            document.addEventListener('keydown', handleEscKey);

            return () => {
                document.body.style.overflow = 'auto';
                document.removeEventListener('keydown', handleEscKey);
            };
        } else {
            document.body.style.overflow = 'auto';
        }
    }, [isFullScreen, toggleFullScreen]);

    if (isFullScreen) {
        return (
            <div className={styles.fullScreenContainer}>
                <button
                    onClick={toggleFullScreen}
                    className={styles.fullScreenCloseButton}
                >
                    <Close size={24} />
                </button>
                    {!imageLoaded && (
                        <Skeleton 
                            variant="rounded" 
                            width="100%" 
                            height="90%" 
                            animation="wave" 
                            sx={{bgcolor: 'grey.700'}}
                        />
                    )}
                    <img
                        src={url}
                        alt="Full Screen Preview"
                        className={styles.fullScreenFile}
                        style={{ display: imageLoaded ? 'block' : 'none' }}
                        onLoad={handleImageLoad}
                    />
            </div>
        );
    }

    return (
        <>
            {!imageLoaded && (
                <Skeleton 
                    variant="rounded" 
                    width="100%" 
                    height={getStyle()} 
                    animation="wave" 
                    sx={{bgcolor: 'grey.700'}}
                />
            )}
            <img
                src={url}
                alt="Preview"
                onClick={toggleFullScreen}
                className={`${styles.previewFile}`}
                style={{
                    height: getStyle(),
                    display: imageLoaded ? 'block' : 'none'
                }}
                onLoad={handleImageLoad}
            />
        </>
    );
};

export default ImagePreview;